import { VentasFacturas } from "../../components";

const VentasFactura = () => <VentasFacturas />;

export default VentasFactura;
